import React, { memo } from "react";
import { twMerge } from "tailwind-merge";
import { Element } from "src/components/base";
import classNames from "classnames";

interface IProps {
    className?: string;
    classNameCheckbox?: string;
    classNameLabel?: string;
    children?: React.ReactNode;
    disabled?: boolean;
    checked?: boolean;
    onChange?: (evt: any) => any;
    name?: string;
}

function Checkbox({
    className = "",
    classNameCheckbox = "",
    classNameLabel = "",
    children,
    disabled = false,
    checked,
    ...rest
}: IProps) {
    return (
        <Element
            className={twMerge(
                "checkbox",
                "relative flex items-center",
                "text-xs[12px] leading-[1.25]",
                "cursor-pointer",
                "disabled:text-[#7a7a7a] disabled:cursor-not-allowed",
                className
            )}
            renderAs="label"
            disabled={disabled}
        >
            <Element
                type="checkbox"
                renderAs="input"
                disabled={disabled}
                checked={checked}
                className={twMerge(
                    "cursor-pointer",
                    "appearance-none",
                    "relative",
                    "border border-solid border-[#a0a0a0]",
                    "mr-[6px] mt-[3px] p-[8px]",
                    "rounded-[999px]",
                    "checked:bg-[color:var(--purple-primary)] checked:border-[color:var(--purple-primary)]",
                    "checked:after:h-[80%] checked:after:w-[40%] checked:after:absolute",
                    "checked:after:border-r-2 checked:after:border-b-2 checked:after:border-solid checked:after:border-white",
                    "checked:after:translate-x-[-50%] checked:after:translate-y-[-63%] checked:after:rotate-45",
                    classNameCheckbox
                )}
                {...rest}
            />
            <Element
                className={classNames(
                    "checkbox-label",
                    "block",
                    classNameLabel
                )}
            >
                {children}
            </Element>
        </Element>
    );
}

export default memo(Checkbox);
